import React, {Component} from 'react';
import {Navbar} from 'react-bootstrap';
import HeaderOptions from './HeaderOptions';
import logo from "asset/img/logo/logo.png";

class Header extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <Navbar inverse collapseOnSelect className={"main-header " + (this.props.className ? this.props.className:'')}>
                <Navbar.Header>
                    <Navbar.Brand className="main-header-brand">
                        <img src={logo} alt="Lakshya Pocket Lab"/>
                        <a href="#home">Lakshya Pocket Lab</a>
                    </Navbar.Brand>
                    <Navbar.Toggle/>
                </Navbar.Header>
                {this.props.headerOption}
            </Navbar>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx